import { AxiosResponse } from 'axios';
import { IRIString } from '../interfaces/IriType';
import ServiceConstructor from './ServiceConstructor';

class IbanUpdateService extends ServiceConstructor {
  public retryRequest(workflowIri: IRIString): Promise<AxiosResponse> {
    return this.postRessource(`${ workflowIri }/retry`, {});
  }

  public cancelRequest(workflowIri: IRIString): Promise<AxiosResponse> {
    return this.postRessource(`${ workflowIri }/cancel`, {});
  }
}

export default IbanUpdateService;
